var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import _ from "lodash";
import VueDialog from "../../interface/IVueDialog";
import PrintConfigService from '../../api/PrintConfigService';
var Dialog = (function (_super) {
    __extends(Dialog, _super);
    function Dialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.clients = [];
        _this.rowData = null;
        _this.clientStatus = null;
        _this.cooperation_status = ['1'];
        _this.copyName = '';
        _this.defaultProps = {
            label: 'business_name',
            id: "supplier_to_business_id"
        };
        return _this;
    }
    Dialog.prototype.created = function () {
        this.service = PrintConfigService.getInstance();
        this.getClients();
    };
    Dialog.prototype.getClients = function () {
        var _this = this;
        var business_status = _.sortBy(this.cooperation_status).join(',');
        this.service.getClientsByGroupTree({
            business_status: business_status
        }).then(function (res) {
            res.data.data.forEach(function (item, index) {
                item.supplier_to_business_id = "group" + index;
                item.business_name = item.group_name;
            });
            _this.clients = res.data.data || [];
        });
    };
    Dialog.prototype.handleCheckedStatusChange = function (val) {
        this.getClients();
    };
    Dialog.prototype.close = function () {
        this.$closeDialog();
    };
    Dialog.prototype.copyConfig = function () {
        var _this = this;
        this.$validator.validateScopes().then(function (res) {
            var supplier_to_business_ids = _this.$refs.applyTree.getCheckedKeys(true).join(',');
            var params = {
                template_id: _this.rowData.template_id,
                template_title: _this.copyName,
                supplier_to_business_ids: supplier_to_business_ids,
                is_alert: '1'
            };
            _this.service.copyConfig(params).then(function (res) {
                if (res.data.success) {
                    if (res.data.msg == '复制成功') {
                        _this.$message.success('复制模板成功！');
                        _this.close();
                        _this.$emit('copyConfig:ok');
                    }
                    else {
                        _this.$confirm(res.data.msg, '提示', {
                            customClass: 'confirm'
                        }).then(function (res) {
                            if (res) {
                                _this.service.copyConfig(Object.assign({}, params, { is_alert: '0' })).then(function (res) {
                                    if (res.data.success) {
                                        _this.$message.success('复制模板成功！');
                                        _this.close();
                                        _this.$emit('copyConfig:ok');
                                    }
                                    else {
                                        _this.$message.error(res.data.msg);
                                    }
                                });
                            }
                        }).catch(function () {
                        });
                    }
                }
                else {
                    _this.$message.error(res.data.msg);
                }
            }, function (err) {
                _this.$message.error(err.message || err.msg);
            });
        });
    };
    Dialog = __decorate([
        Component
    ], Dialog);
    return Dialog;
}(VueDialog));
export default Dialog;
